import React from 'react';
import { Dropdown } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileCode } from '@fortawesome/free-solid-svg-icons';
import PropTypes from 'prop-types';
import useToken from 'hooks/useToken';
import { useNavigate } from 'react-router-dom';
import { useToast } from 'context/providers/ToastProvider';

const computeAniomesFromDate = (dateValue) => {
    try {
        if (!dateValue) return null;
        const d = new Date(dateValue);
        if (isNaN(d.getTime())) return null;
        const y = d.getFullYear();
        const m = (d.getMonth() + 1).toString().padStart(2, '0');
        return `${y}${m}`;
    } catch {
        return null;
    }
};

const DescargarXML = ({
    vUUIDFactura,
    dFechaEmision,
    vRfcEmisor,
    esFacturaRecibida = false }) => {

    const { showErrorToast, showSuccessToast } = useToast();
    const { token, setToken } = useToken();
    const navigate = useNavigate();

    const handleClick = async () => {
        try {
            const uuid = vUUIDFactura;
            const fecha = dFechaEmision;
            const aniomes = computeAniomesFromDate(fecha);
            const rfc = vRfcEmisor;

            if (!uuid || !aniomes) {
                showErrorToast('No se pudo determinar UUID o A�oMes para la factura.');
                
                return;
            }

            showSuccessToast('Iniciando descarga de XML...');            

            // Construir URL agregando el par�metro esRecibida
            let url = `/api/Facturas/DescargarXmlFactura?uuid=${encodeURIComponent(uuid)}&aniomes=${encodeURIComponent(aniomes)}&esRecibida=${esFacturaRecibida}`;
            if (rfc) url += `&rfc=${encodeURIComponent(rfc)}`;

            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Authorization': 'Bearer ' + token
                }
            });

            if (response.ok) {
                const text = await response.text();
                const blob = new Blob([text], { type: 'application/xml' });
                const downloadName = `${uuid}.xml`;
                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = downloadName;
                document.body.appendChild(link);
                link.click();
                link.remove();
            } else {
                if (response.status === 401) {
                    setToken(null);
                    navigate('/');
                    return;
                }
                const err = await response.json().catch(() => null);
                showErrorToast(err?.vMessage || `Error al descargar XML ${uuid}: ${response.status} ${response.statusText}`);
                
            }

        } catch (error) {
            showErrorToast('Error al descargar XML: ' + error);
            
        }
    };

    return (
        <Dropdown.Item onClick={handleClick}>
            <FontAwesomeIcon icon={faFileCode} className="me-2" />
            Descargar XML
        </Dropdown.Item>
    );
};

DescargarXML.propTypes = {
    vUUIDFactura: PropTypes.string,
    dFechaEmision: PropTypes.string,
    vRfcEmisor: PropTypes.string,
    esFacturaRecibida: PropTypes.bool
};

export default DescargarXML;
